import { ServicePricingInputs } from '../components/ServicePricingInputs';
// in src/posts.js
import * as React from 'react';
import { useState, useEffect } from 'react';

import {
  List, 
  Datagrid,
  TextField,
  EditButton,
  Edit,
  Create,
  SimpleForm,
  ReferenceInput,
  SelectInput,
  TextInput, 
  CreateButton ,
  TopToolbar,
  FormTab,
  TabbedForm,
  ReferenceManyField,
  Filter, required, BooleanInput, useDataProvider, FunctionField, NumberInput,
  Button, useNotify
    
} from 'react-admin';

import { EditableDatagrid, RowForm } from '@react-admin/ra-editable-datagrid';

import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

import {useMediaQuery } from '@material-ui/core';
//import Chip from '@material-ui/core/Chip';
import Chip from '@mui/material/Chip';

import { useForm, useFormState } from 'react-final-form';


import { PermissionsList  } from './users_permissions';


import { useTranslate, choicesLanguage, defaultLanguage  } from '../common/language';

import { targetsEmails, apiUrl, contexts } from '../common/constants';import { headersAPIObjectAuth } from '../common/utils';
import { SendEmailIconStatus } from '../components/Emails';
import Box from '@mui/material/Box';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import MuiTextField from '@mui/material/TextField';


import {
  DateField,
  DateInput
} from 'react-admin';




import { validateEmail, validateMaxLength  } from './../components/Validator';

export const AssociationsList = (props) => {
    
  const translate = useTranslate();      
  const isSmall = useMediaQuery(theme => theme.breakpoints.down('sm'));
  
  const [modulesMap, setModulesMap] = useState({}); 

  useEffect(() => {
       
    fetch(apiUrl + '/modules?page=0&size=1000', { headers: headersAPIObjectAuth() } ) 
      .then(res => res.json())
      .then(data => {
        const modulesArray = data.content || [];

        const map = {};

        modulesArray.forEach(m => {
          map[m.id] = m.name;  // id => nom traduït
        });

        setModulesMap(map);
      })
      .catch(err => {
        console.error('Error carregant modules', err);
      });
  }, []);
  
  if (!modulesMap) return null;
  
  return (
    <List {...props}         
      sort={{ field: 'id', order: 'DESC' }}  
      filters={<AssociationsFilter />}
      bulkActionButtons={false} 
      resource="associations"
      basePath="/associations"
      perPage={50}
      actions={<ListActions/>}
      filterDefaultValues={ { only_current: true, q: "" }}
    >
        
      <Datagrid>                    
        <TextField source="name" label={translate('common.name')} sortable={false} />
        <FunctionField render={record => chipsSubscriptions(record.subscriptions, modulesMap) } label={translate('associations.subscriptions')} sortable={false}  /> 
        <FunctionField label={translate('associations.trial')} render={record => 
            <SendEmailIconStatus record={record} target={targetsEmails.ASSOCIATIONS_TRIAL}  />
        } sortable={false}  />
        <FunctionField label={translate('associations.end')} render={record => 
            <SendEmailIconStatus record={record} target={targetsEmails.ASSOCIATIONS_END}  />
        } sortable={false}  />
        <TextField source="num_users" label={translate('associations.report_users')} sortable={false} />
        <TextField source="num_groups" label={translate('associations.report_groups')} sortable={false} />
        <TextField source="num_emails" label={translate('associations.report_emails')} sortable={false} />
        <TextField source="num_emails_failed" label={translate('associations.report_emails_not_sent')} sortable={false} />
        <TextField source="num_docs" label={translate('associations.report_docs')} sortable={false} />
        <TextField source="total_size" label={translate('associations.report_mb')} sortable={false} />
        <TextField source="num_remittances" label={translate('associations.report_remittances')} sortable={false} />
        <TextField source="num_remittances_users" label={translate('associations.report_remittances_users')} sortable={false} />
        <DateField source="last_action" showTime  label={translate('associations.report_last_action')}/>
                    
                    

        <EditButton label="" />
      </Datagrid>
        
    </List>
  );
};

/*
 * <ArrayField source="subscriptions" label={translate('associations.subscriptions')} sortable={false} >
                        <SingleFieldList>
                            <ChipField source="modules.name" />
                        </SingleFieldList>
                    </ArrayField>
 */

const chipsSubscriptions = (subscriptions, modulesMap) => {
  let i = 0;
  let strChips = '';
    
  let arrSubscriptions = [];
  for(i=0;i<subscriptions.length ;i++)
  {
    //strChips+=subscriptions[i].modules.name + " - " + subscriptions[i].modules_options.name;
    let date_expiration = subscriptions[i].date_expiration.substr(0,10);
    let date = new Date(subscriptions[i].date_expiration.substr(0,10));
    let dateNow = new Date();
    var date30d = new Date();
    date30d.setDate(dateNow.getDate()+30);
        
    let color = 'green';
    if (date <= dateNow)
      color = 'red';
    else if (date <= date30d)
      color = 'orange';
    
    const moduleName = modulesMap[subscriptions[i].modules_id] || 'Unknown';
    
    let aux_subscription = React.createElement(Chip, {label: moduleName , className: 'chip ' + color } );
    arrSubscriptions.push(aux_subscription);
  }
  const list = React.createElement('div', {}, arrSubscriptions);
                        
  return list;
};
                        

const ListActions = (props) => (
  <TopToolbar>        
    <CreateButton {...props} />
  </TopToolbar>
);

export const AssociationsEdit  = ({ id, ...props }) => {

  const translate = useTranslate();   
    
  const dataProvider = useDataProvider();
  const notify = useNotify();
  const [info, setInfo] = useState();
  const [modulesMap, setModulesMap] = useState({}); 
  const [ticketsModuleId, setTicketsModuleId] = useState();
  const [testEventDialogOpen, setTestEventDialogOpen] = useState(false);
  const [generatingTestEvent, setGeneratingTestEvent] = useState(false);
  const [testEventCount, setTestEventCount] = useState(1);
  const [testTicketCount, setTestTicketCount] = useState(15);
  const [deleteTestEventsDialogOpen, setDeleteTestEventsDialogOpen] = useState(false);
  const [deletingTestEvents, setDeletingTestEvents] = useState(false);
    
  const today = new Date().toISOString().slice(0, 10);
  const future = new Date('2099-12-31').toISOString();

  useEffect(() => {
        
    dataProvider.getOne('associations', { id: id })
      .then(({ data }) => {     
        setInfo(data);
      })
      .catch(error => {           
      });
       
  }, []);

  useEffect(() => {
    
    fetch(apiUrl + '/modules?page=0&size=1000', { headers: headersAPIObjectAuth() } ) 
      .then(res => res.json())
      .then(data => {
        const modulesArray = data.content || [];

        const map = {};

        modulesArray.forEach(m => {
          map[m.id] = m.name; 
          if (m.public_id === 'TICKETS') setTicketsModuleId(m.id);
        });

        setModulesMap(map);
      })
      .catch(err => {
        console.error('Error loading modules', err);
      });
  }, []);

  const hasTicketsModule = info && ticketsModuleId && (info.subscriptions || []).some(subscription => {
    if (Number(subscription.modules_id) !== Number(ticketsModuleId)) return false;
    return !subscription.date_expiration || new Date(subscription.date_expiration) >= new Date();
  });
  const canManageTestEvents = localStorage.getItem('permissions_groups') === 'SIFAC'
    && localStorage.getItem('email') === 'admin@softovi.com';
  const canGenerateTestEvent = canManageTestEvents && hasTicketsModule;

  const generateTestEvent = async () => {
    const eventCount = Number(testEventCount);
    const ticketCount = Number(testTicketCount);
    if (!Number.isInteger(eventCount) || eventCount < 1 || eventCount > 100) {
      notify(translate('associations.generate_tickets_test_event_invalid_event_count'), 'warning');
      return;
    }
    if (!Number.isInteger(ticketCount) || ticketCount < 1 || ticketCount > 100000) {
      notify(translate('associations.generate_tickets_test_event_invalid_count'), 'warning');
      return;
    }
    setGeneratingTestEvent(true);
    try {
      const response = await fetch(apiUrl + '/ara-tiquets/admin/associations/' + id
        + '/test-event?ticket_count=' + encodeURIComponent(ticketCount)
        + '&event_count=' + encodeURIComponent(eventCount), {
        method: 'POST',
        headers: headersAPIObjectAuth()
      });
      const result = await response.json().catch(() => ({}));
      if (!response.ok) throw new Error(result.message || result.error || translate('common.error'));
      setTestEventDialogOpen(false);
      notify(result.msg || translate('associations.test_event_created'), 'success');
    } catch (error) {
      notify(error.message, 'error');
    } finally {
      setGeneratingTestEvent(false);
    }
  };

  const deleteTestEvents = async () => {
    setDeletingTestEvents(true);
    try {
      const response = await fetch(
        apiUrl + '/ara-tiquets/admin/associations/' + id + '/test-events', {
          method: 'DELETE',
          headers: headersAPIObjectAuth()
        });
      const result = await response.json().catch(() => ({}));
      if (!response.ok) throw new Error(result.message || result.error || translate('common.error'));
      setDeleteTestEventsDialogOpen(false);
      notify(result.msg || translate('associations.test_events_deleted'), 'success');
    } catch (error) {
      notify(error.message, 'error');
    } finally {
      setDeletingTestEvents(false);
    }
  };
  
  if (!modulesMap) return null;
  
  return (
    
    <>
      <br />
      <Typography variant="h5" className="grey8" >
        {info ? info.name : null }              
      </Typography>
      {canManageTestEvents ?
        <Box mt={2} mb={1} display="flex" style={{ gap: 12 }}>
          {canGenerateTestEvent ?
          <Button
            label={translate('associations.generate_tickets_test_event')}
            onClick={() => setTestEventDialogOpen(true)}
            disabled={generatingTestEvent}
          />
          : null}
          <Button
            label={translate('associations.delete_tickets_test_events')}
            onClick={() => setDeleteTestEventsDialogOpen(true)}
            disabled={deletingTestEvents}
            style={{ color: '#c62828' }}
          />
        </Box>
      : null}
      <Dialog open={testEventDialogOpen} onClose={() => !generatingTestEvent && setTestEventDialogOpen(false)}>
        <DialogTitle>{translate('associations.generate_tickets_test_event')}</DialogTitle>
        <DialogContent>
          <Typography gutterBottom>{translate('associations.generate_tickets_test_event_confirm')}</Typography>
          <MuiTextField
            autoFocus
            fullWidth
            margin="normal"
            type="number"
            label={translate('associations.generate_tickets_test_event_event_count')}
            value={testEventCount}
            inputProps={{ min: 1, max: 100, step: 1 }}
            onChange={event => setTestEventCount(event.target.value)}
            disabled={generatingTestEvent}
          />
          <MuiTextField
            fullWidth
            margin="normal"
            type="number"
            label={translate('associations.generate_tickets_test_event_count')}
            value={testTicketCount}
            inputProps={{ min: 1, max: 100000, step: 1 }}
            onChange={event => setTestTicketCount(event.target.value)}
            disabled={generatingTestEvent}
          />
        </DialogContent>
        <DialogActions>
          <Button
            label={translate('ra.action.cancel')}
            onClick={() => setTestEventDialogOpen(false)}
            disabled={generatingTestEvent}
          />
          <Button
            label={translate('associations.generate')}
            onClick={generateTestEvent}
            disabled={generatingTestEvent}
          />
        </DialogActions>
      </Dialog>
      <Dialog
        open={deleteTestEventsDialogOpen}
        onClose={() => !deletingTestEvents && setDeleteTestEventsDialogOpen(false)}
      >
        <DialogTitle>{translate('associations.delete_tickets_test_events')}</DialogTitle>
        <DialogContent>
          <Typography>{translate('associations.delete_tickets_test_events_confirm')}</Typography>
        </DialogContent>
        <DialogActions>
          <Button
            label={translate('ra.action.cancel')}
            onClick={() => setDeleteTestEventsDialogOpen(false)}
            disabled={deletingTestEvents}
          />
          <Button
            label={translate('ra.action.delete')}
            onClick={deleteTestEvents}
            disabled={deletingTestEvents}
            style={{ color: '#c62828' }}
          />
        </DialogActions>
      </Dialog>
    
      <Edit title={<ElementTitle />} {...props}  id={id}
        mutationMode="pessimistic"> 
    
        <TabbedForm>
          <FormTab
            label={translate('associations.tab_subscriptions')}
          >

            <ReferenceManyField
              fullWidth
              reference="subscriptions"
              target="associations_id"
              label=""
            >

              <EditableDatagrid   
                fullWidth
                createForm={<OptionForm initialValues={{ associations_id: id, date_init: today, date_expiration : future }} edit={false} />}
                editForm={<OptionForm edit={true} />}
                label=""
                hasCreate
              >
                <FunctionField render={record => modulesMap[record.modules_id] || 'Unknown'} label={translate('subscriptions.module')} sortable={false}  /> 
                <TextField fullWidth source="modules_options.name" label={translate('subscriptions.option')} sortable={false} />
                <DateField source="date_init" label={translate('subscriptions.date_init')} sortable={false} />
                <DateField source="date_expiration" label={translate('subscriptions.date_expiration')} sortable={false} />
                 
              </EditableDatagrid>

            </ReferenceManyField> 

          </FormTab>

          <FormTab
            label={translate('associations.tab_admin')}             
          >
          <Box sx={{ width: '100%', maxWidth: '100%', flexGrow: 1 }}>
            <PermissionsList associations_id={id} redirect={'/associations/' + id + '/1'} {...props} context={contexts.GESTIOENTITATS} />   
          </Box>
          </FormTab>
            
          <FormTab
            label={translate('associations.tab_data')}
          >  
            <Grid container spacing={1} >
                <Grid item xs={12} sm={12}>
                    <TextInput fullWidth source="name" label={translate('common.name')} validate={[required(),validateMaxLength(100,translate('common.validation.maxLength'))]} />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <SelectInput
                      source="lang"
                      label={translate('common.language_association')}
                      choices={choicesLanguage(translate, window.location.hostname === 'localhost' || window.location.hostname === 'admin.gestioentitats.cat' )}                      
                      validate={[required()]}
                      fullWidth
                    />
                </Grid>
            </Grid>
          </FormTab>

          <FormTab label={translate('settings.commissions')}>
            <Box sx={{ width: '100%', maxWidth: 850 }}>
              <ServicePricingInputs />
            </Box>
          </FormTab>

        </TabbedForm>
    
      </Edit>
    </>
  );
};

/*
 * <FormTab
                label={translate('associations.tab_statistics')}
            >

            <br />
            <Card fullWidth>
                <CardHeader title="Estadístiques" />
                <CardContent>Aquí apareixeran dades estadístiques de l'associació.</CardContent>
            </Card>

            </FormTab>          
 */

export const AssociationsCreate = props => {
  const translate = useTranslate();   
  return (
    <Create {...props} resource="auth/signup">
      <SimpleForm redirect="edit">
      <Grid container spacing={1} >
        <Grid item xs={12} sm={12}>
            <TextInput fullWidth source="name" label={translate('common.name')} validate={[required(),validateMaxLength(100,translate('common.validation.maxLength'))]} />   
        </Grid>
        <Grid item xs={12} sm={12}>
            <TextInput fullWidth label={translate('associations.email_property')} fullWidth source="email" validate={[validateEmail(),required()]} className="bg-grey mt-0"  />
            <span>{translate('associations.signup_message')}</span>
        </Grid>   
        <Grid item xs={12} sm={6}>
            <br/>
            <SelectInput
              source="lang"
              label={translate('common.language_association')}
              choices={choicesLanguage(translate, window.location.hostname === 'localhost' || window.location.hostname === 'admin.gestioentitats.cat' )}                      
              validate={[required()]}
              fullWidth
              defaultValue={defaultLanguage}
            />
        </Grid>
        <Grid item xs={12} sm={12}>
            <BooleanInput source="generate_data_demo" label={translate('associations.generate_data_demo')} />   
        </Grid>
      </Grid>              
      </SimpleForm>
    </Create>
  );
};

const OptionsInput = props => {
  const translate = useTranslate();   
  const { values } = useFormState();
  return (
    values.modules_id ? 
      <ReferenceInput sort={{ field: 'priority', order: 'ASC' }} label={translate('subscriptions.option')} source="modules_options_id" reference="modules_options" filter={{ modules_id : values.modules_id }}>
        <SelectInput fullWidth optionText="name" optionValue="id" validate={required()} />
      </ReferenceInput> : ''
  );
};


const OptionForm= ({edit, ...props}) => {
  const translate = useTranslate();   
  const { values } = useFormState();
  return (
    <RowForm {...props}>
      <ReferenceInput label={translate('subscriptions.module')} source="modules_id" reference="modules"  sort={{ field: 'priority', order: 'ASC' }} >
        { edit ? (
          <SelectInput fullWidth optionText="name" optionValue="id" validate={required()} disabled />
        ) : (
          <SelectInput fullWidth optionText="name" optionValue="id" validate={required()} />
        ) }
      </ReferenceInput> 
      <OptionsInput source="modules_options_id" label={translate('subscriptions.option')}  />
      <DateInput source="date_init" validate={required()} label={translate('subscriptions.date_init')} />
      <DateInput source="date_expiration" validate={required()} label={translate('subscriptions.date_expiration')} />
    </RowForm>
  );
};




const AssociationsFilter = (props) => 
{ 
  const translate = useTranslate(); 
  return (
    <Filter {...props}>
      <TextInput label={translate('common.search')} source="q" alwaysOn validate={[validateMaxLength(100,translate('common.validation.maxLength'))]} />  
      <AssociationsModuleFilterInput source="modules_id" alwaysOn />
      <AssociationsOptionsFilterInput source="modules_options_id" alwaysOn />
      <BooleanInput label={translate('associations.only_current')} source="only_current" alwaysOn />
    </Filter>
  );
};

const AssociationsModuleFilterInput = ({ source, ...props }) => {
  const translate = useTranslate();
  const { change } = useForm();

  const handleChangeModule = () => {
    change('modules_options_id', 0);
  };

  return (
    <ReferenceInput {...props} label={translate('subscriptions.module')} source={source} reference="modules" perPage={1000} sort={{ field: 'priority', order: 'ASC' }}>
      <SelectInput optionText="name" optionValue="id" resettable parse={value => value ? Number(value) : 0} onChange={handleChangeModule} />
    </ReferenceInput>
  );
};

const AssociationsOptionsFilterInput = ({ source, ...props }) => {
  const translate = useTranslate();
  const { values } = useFormState();

  return (
    values.modules_id ?
      <ReferenceInput {...props} label={translate('subscriptions.option')} source={source} reference="modules_options" perPage={1000} sort={{ field: 'priority', order: 'ASC' }} filter={{ modules_id : values.modules_id }}>
        <SelectInput optionText="name" optionValue="id" resettable parse={value => value ? Number(value) : 0} />
      </ReferenceInput> : null
  );
};


/*const ListActions = (props) => (
    <TopToolbar>
        {cloneElement(props.filters, { context: 'button' })}
        <CreateButton/>
        <ExportButton />        
    </TopToolbar>
);*/



const AssociationsTitle = ({ record }) => {
  return <span>Editar {record ? `"${record.name}"` : ''}</span>;
};


const ElementTitle = ({ record }) => {
  return <span>Editar {record ? `"${record.name}"` : ''}</span>;
};


